export default __webpack_public_path__ + "static/media/task_dark.97d525ba.svg";